<template>
  <div class="fb_wrap">
    <div class="b_close" @click="$modal.hide('modal')">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
        <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
      </svg>
    </div>
    <div class="blue_border">
      <div class="title">Обратная связь</div>
      <div class="form_row">
        <div class="input_wrap">
          <input v-model="userStore.fb.fields.name" id="input_fb_name" type="text" class="input_gray">
          <label for="input_fb_name" class="input_label">ФИО</label>
        </div>
      </div>
      <div class="form_row">
        <div class="input_wrap">
          <input v-model="userStore.fb.fields.phone" id="input_fb_phone"  type="tel" pattern="[0-9]-[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}" class="input_gray">
          <label for="input_fb_phone" class="input_label">Телефон</label>
        </div>
      </div>
      <div class="form_row">
        <div class="input_wrap">
          <input v-model="userStore.fb.fields.email" id="input_fb_email" type="text" class="input_gray">
          <label for="input_fb_email" class="input_label">E-mail</label>
        </div>
      </div>
      <div class="form_row">
        <div class="text_wrap">
          <label for="input_fb_message" class="input_label">Сообщение</label>
          <textarea class="textarea_gray" name="message" v-model="userStore.fb.fields.message" id="input_fb_message"></textarea>
        </div>
      </div>
      <div class="form_row">
        <div class="send_wrap" v-if="!userStore.fb.is_loading">
          <div class="send_button" @click="send_fb">Отправить</div>
        </div>
        <div v-else class="send_wrap">
          <loading></loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/UserStore'
import loading from "@/components/support/loading";
export default {
  name: 'auth',
  components: {
    loading,
  },
  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },
  data: function (){
    return {
    }
  },
  methods: {
    send_fb(){
      this.$notifyInfo('Форма - отправлена');
      this.userStore.send_fb().then(this.response_process);
    },
    response_process(reqResult) {
      if (typeof (reqResult.type !== "undefined") && reqResult.type === 'success') {
        this.$notifySuccess(reqResult.message);
      } else if (typeof (reqResult.type !== "undefined") && reqResult.type === 'info') {
        this.$notifyInfo(reqResult.message);
      } else {
        this.$notifyError(reqResult.message);
        if(typeof (reqResult.notice) === 'object')
        {
          for(const index in reqResult.notice)
          {
            console.log(reqResult.notice[index].message,index)
            if(typeof (reqResult.notice[index].message) != 'undefined')
            {
              this.$notifyWarning(reqResult.notice[index].message);
            }
          }
        }

      }
    },
  }
}
</script>

<style scoped>
.fb_wrap .blue_border {
  margin: 50px 5% 50px 5%;
}
.fb_wrap .form_row {
  margin: 0 0 15px 0;
}
.fb_wrap .input_wrap {
  width: 100%;
  margin-right: 0px;
}
.fb_wrap .input_gray {
  width: 94%;
  padding-left: 2.5%;
  padding-right: 2.5%;
}
.fb_wrap .text_wrap {
  width: 100%;
}
.fb_wrap .textarea_gray {
  margin: 0 0 0 0;
  width: 94%;
  padding-left: 2.5%;
  padding-right: 2.5%;
}
.fb_wrap  .send_wrap {
  width: 100%;
  margin-bottom: 15px;
}
.fb_wrap .send_button {
  width: 99%;
  margin: 0px;
}
</style>

